export const forwardOptions = [
  { value: 'channel', label: 'Channel' },
  { value: 'user', label: 'User' },
];
